import PhaseSixIcon from "../phaseSixIcon/PhaseSixIcon";
import type { KeyboardEvent } from "react";

interface CheckboxProps {
    isChecked: boolean;
    isPartial?: boolean;
    onClick?: () => void;
    ariaLabel?: string;
    "data-testid"?: string;
    /** Overrides the default orange when checked. */
    checkedClassName?: string;
    isRecurringTask?: boolean;
}

const Checkbox = (props: CheckboxProps) => {
    const isInteractive = !!props.onClick;

    const getStateClass = (): string => {
        if (props.isChecked) {
            if (props.checkedClassName) {
                return props.checkedClassName;
            }
            return props.isRecurringTask ? "border-forest-green-800 bg-forest-green-800" : "border-p6-orange bg-p6-orange";
        }
        if (props.isPartial) {
            return "border-p6-grey-mid bg-p6-grey-mid";
        }
        return "border-p6-grey-mid";
    };

    const getAriaChecked = (): boolean | "mixed" | undefined => {
        if (!isInteractive) {
            return undefined;
        }
        if (props.isChecked) {
            return true;
        }
        if (props.isPartial) {
            return "mixed";
        }
        return false;
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            props.onClick?.();
        }
    };

    return (
        <div
            role={isInteractive ? "checkbox" : "presentation"}
            aria-checked={getAriaChecked()}
            aria-label={isInteractive ? props.ariaLabel : undefined}
            data-testid={props["data-testid"]}
            tabIndex={isInteractive ? 0 : undefined}
            className={`w-[20px] h-[20px] shrink-0 rounded-[3px] border flex items-center justify-center ${
                isInteractive ? "cursor-pointer" : ""
            } ${getStateClass()}`}
            onClick={props.onClick}
            onKeyDown={isInteractive ? handleKeyDown : undefined}
        >
            {props.isChecked && (
                <PhaseSixIcon
                    name="exercise-ok"
                    className="text-white text-l"
                />
            )}
            {!props.isChecked && props.isPartial && (
                <span className="text-white text-xl leading-none -translate-y-[3px]">-</span>
            )}
        </div>
    );
};

export default Checkbox;
